export default "__VITE_ASSET__COa$HvQU__"